import { Component, OnInit } from '@angular/core';
import { SearchJudgmentsService } from '../../core/services/search-judgments.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-search-judgments',
  templateUrl: './search-judgments.component.html',
  styleUrls: ['./search-judgments.component.scss'],
})
export class SearchJudgmentsComponent implements OnInit {
  breadcrumbs = [
    {
      title: 'Search Judgments',
    },
  ];

  data: any[] = [];
  totalDocs = 0;
  currentPage = 1;
  pageSize = 24;
  searchVal = '';
  searchField = 'all';
  hasSearched = false;

  searchFields = [
    { value: 'all', label: 'All Fields' },
    { value: 'caseNo', label: 'Case No' },
    { value: 'dateOfJudgment', label: 'Date of Judgment' },
    { value: 'namesOfParties', label: 'Names of the Parties' },
    { value: 'judgmentBy', label: 'Judgment By' },
  ];

  constructor(
    private searchJudgmentsService: SearchJudgmentsService,
    private datePipe: DatePipe,
  ) {}

  ngOnInit(): void {}

  getFieldLabel(): string {
    const field = this.searchFields.find((f) => f.value === this.searchField);
    return field ? field.label : 'All Fields';
  }

  search(): void {
    if (!this.searchVal || this.searchVal.trim() === '') {
      this.data = [];
      this.hasSearched = false;
      return;
    }

    this.currentPage = 1;
    this.hasSearched = true;
    this.performSearch();
  }

  performSearch(): void {
    this.searchJudgmentsService
      .searchJudgments(this.searchVal, this.searchField, this.currentPage, this.pageSize)
      .then((response: any) => {
        this.data = response.docs || [];
        this.totalDocs = response.totalDocs || 0;
      });
  }

  clearSearch(): void {
    this.searchVal = '';
    this.searchField = 'all';
    this.data = [];
    this.hasSearched = false;
    this.currentPage = 1;
    this.totalDocs = 0;
  }

  onCurrentPageDataChange(page: number): void {
    this.currentPage = page;
    this.performSearch();
  }

  getFileUrl(file: any): string {
    if (file && file.url) {
      return file.url;
    }
    if (file && typeof file === 'string') {
      return file;
    }
    return '#';
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';
    const date = new Date(dateString);
    return this.datePipe.transform(date, 'dd MMM yyyy') || '';
  }

  handleKeyPress(event: KeyboardEvent): void {
    if (event.key === 'Enter') {
      this.search();
    }
  }
}




